/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import api from "../../../services/api";
import moment from "moment";

import FixedContainer from "../../../components/Container";
import {
  Box,
  Button,
  Typography,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { GetFetch, PostFetch, urls } from "../../../services/apiBase";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useAuth } from "../../../hooks/auth";
const NewCpr = (props) => {
  dayjs.extend(utc)

  const clientTimeDict = [
    {keyTime: 'months', cprDuration: 6, label: '6 meses'},
    {keyTime: 'months', cprDuration: 12, label: '12 meses'},
    {keyTime: 'months', cprDuration: 24, label: '24 meses'},
    {keyTime: 'months', cprDuration: 36, label: '36 meses'},
    {keyTime: 'months', cprDuration: 48, label: '48 meses'}
  ]

  const navigate = useNavigate();
  const { user } = useAuth();

  const [query, setQuery] = useState('');

  const [personneList, setPersonneList] = useState([]);
  const [person_name_id, setPersonne_name_id] = useState(null);
  const [selectedPersonInfo, setSelectedPersonInfo] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);

  const [isRenew, setIsRenew] = useState(false);
  const [isRenewSelected, setIsRenewSelected] = useState(false);

  const [cprsHeldByClient, setCprsHeldByClient] = useState([]);
  const [cprsSelectedToRenew, setCprsSelectedToRenew] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [signDate, setSignDate] = useState(null);

  const [cprType, setCprType] = useState("bullet");
  const [registerMode, setRegisterMode] = useState("B3");
  const [brokerage, setBrokerage] = useState("BRP");
  const [brokerageTax, setBrokerageTax] = useState(true);

  const [custody, setCustody] = useState("FINPEC");
  const [instrumentType, setInstrumentType] = useState("CPR");

  const [firstCupomDate, setFirstCupomDate] = useState(null);
  const [finalDate, setFinalDate] = useState(null);

  const [allowFirstCupomDate, setAllowFirstCupomDate] = useState(false);
  const [allowFinalDate, setAllowFinalDate] = useState(false);

  const [amount_cpr, setAmount_cpr] = useState('');
  const [rate_cpr, setRate_cpr] = useState('');
  const [keyTime, setKeyTime] = useState("years");
  const [cprDuration, setCprDuration] = useState(1);
  const [createPDF, setCreatePDF] = useState("createCprPDF");
  const [note, setNote] = useState("");
  const [load, setLoad] = useState(false);

  const [isOpportunity, setIsOpportunity] = useState(false);
  const [loadingOpportunities, setLoadingOpportunities] = useState(false);
  const [opportunitiesList, setOpportunitiesList] = useState([]);
  const [opportunitySelected, setOpportunitySelected] = useState(null);
  const [opportunityErrorAmount, setOpportunityErrorAmount] = useState(false);
  const [initLoadSuccess, setInitLoadSuccess] = useState(false);


  const [clientType, setClientType] = useState('cliente')
  const [selectedClientTime, setSelectedClientTime] = useState(clientTimeDict[0])

  const isWeekend = (date) => {
    const day = date.day();

    return day === 0 || day === 6;
  };

  const createOptions = (options) => {
    let optionsAux = [];
    for (let i = 0; i < options.length; i++) {
      let element = options[i];
      optionsAux.push({ label: element.name, value: element.id, user: element.users });
    }
    setSelectOptions(optionsAux);
  };

  const formatDate = (date) => {
    return moment.utc(new Date(date)).format("MM/DD/YYYY");
  };

  const formatCurrency = (value) => {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const formatToDecimal = (value) => {
    if (!value) {
      return '';
    }
    const rawValue = value.replace(/[^\d]/g, '') // Remove caracteres não numéricos
    const numericValue = parseFloat(rawValue) / 100 // Converte para número
    const formattedValue = numericValue.toLocaleString("pt-BR", { style: "decimal", minimumFractionDigits: 2 }) // Formata o valor
  
    return formattedValue; // Exibe o valor formatado
  }

  const formatCurrencyToSave = (value) => {
    if (!value) return 0;
    const numericValue = value.replace(/\./g, '').replace(',', '.');
    return parseInt(numericValue);
  }

  const handleLoadPersonne = async () => {
    try {
      setInitLoadSuccess(true);
      // const response = await GetFetch(urls.GET_LIST_PERSONNE);
      const response = await GetFetch(`/subscription/personne?page=1&limit=100&name=${query}&sortField=name&sortType=asc`);
      console.log({data: response.data})
      setPersonneList(response.data.data);
      createOptions(response.data.data);
      setInitLoadSuccess(false);
    } catch (error) {
      console.error("Loading User", error);
      setInitLoadSuccess(false);
    }
  };

  useEffect(() => {
    console.log('LOADING PERSONNE')
    // Implementando um debounce para evitar múltiplas buscas em sequência
    const searchDebouncedHandler = setTimeout(() => {
      // Faz a busca apenas se o usário digitou pelo menos 3 caracteres
      if (query.length >= 3) {
        handleLoadPersonne();
      }
    }, 300);
    
    return () => {
      clearTimeout(searchDebouncedHandler);
    }
  }, [query]);  

  const handleLoadOpportunities = async () => {
    setLoadingOpportunities(true);
    try {
      let url = urls.GET_LIST_OPPORTUNITIES.concat(`?personne_id=${user.personne_id}`);
      const response = await GetFetch(url, {personne_id: user.personne_id});
      setOpportunitiesList(response.data);
      setLoadingOpportunities(false);
    } catch (error) {
      setLoadingOpportunities(false);
    }
  };

  const handleNote = async (cpr_id, note, user) => {
    try {
      const response = await PostFetch(`/financial/cpr/notes`, {
        cpr_id: cpr_id,
        comment: note,
        username: user,
      });

      return response;
    } catch (e) {
      console.error(e);
    }
  };

  const getCreatePDF = useCallback(async () => {
    try {
      const response = await api.get("/system/config?key=CREATE_PDF_DOCUMENT");
      const responseArray = response.data[0].value;
      if (responseArray.length > 0) {
        setCreatePDF(responseArray);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  /** Error and message for fails during creation checks.
   * @param message Message displayed after success or error.
   * @param isSuccess True if the creation was succesful, or false otherwise.
   */
  const creationSuccessOrError = (message, isSuccess) => {
    enqueueSnackbar(message, { variant: isSuccess ? "success" : "error" });
  };

  const handleCreateCPR = async (
    personne,
    start,
    sign,
    amount,
    type,
    rate,
    duration
  ) => {
    try {
      setLoad(true);
      if (!personne) {
        creationSuccessOrError("Selecione um Cliente");
        return;
      }
      if (!start) {
        creationSuccessOrError("Selecione uma data de inicio");
        return;
      }
      if (!sign) {
        creationSuccessOrError("Selecione uma data de assinatura");
        return;
      } 

      if(dayjs(start).format("YYYY-MM-DD") <  dayjs(new Date()).format("YYYY-MM-DD")){
        creationSuccessOrError("A data de geração deve ser igual ou posterior à data atual");
        return;
      }

      if(dayjs(sign).format("YYYY-MM-DD") <  dayjs(start).format("YYYY-MM-DD")){
        creationSuccessOrError("A data de assinatura deve ser igual ou posterior à data de geração");
        return;
      }
      if (!amount) {
        creationSuccessOrError("Insira o valor do investimento");
        return;
      }
      if (!type) {
        creationSuccessOrError("Selecione o tipo");
        return;
      }
      if (rate < 0) {
        creationSuccessOrError("A taxa não pode ser negativa");
        return;
      }
      if (duration === 0) {
        creationSuccessOrError("Duração tem que ser maior que zero");
        return;
      }
      const user = JSON.parse(localStorage.getItem("user"));
      const requestData = {
        rate_cpr: parseFloat(rate_cpr),
        amount_cpr: formatCurrencyToSave(amount_cpr),
        date_start: formatDate(startDate),
        date_signed: formatDate(signDate),
        personne_id: personne.value,
        type: type,
        register_mode: registerMode,
        brokerage_name: brokerage,
        investor_custody: custody,
        instrument_type: instrumentType,
        username: user.username,
        duration: parseInt(duration),
        key_time: keyTime,
        renewal_cpr_id: cprsSelectedToRenew,
        is_brokerage: brokerageTax
      };

      let typeUser = 'cliente'
      if (personne.user?.length > 0) {
        const [ userType ] = personne.user
        console.log('userType', {type: userType.type})
        typeUser = userType.type
      }

      allowFirstCupomDate &&
      (requestData.firstCupomDate = formatDate(firstCupomDate));
      allowFinalDate && (requestData.finalDate = formatDate(finalDate));
      
      const response = await PostFetch(`/financial/createCpr`, requestData);
      if (response.data?.status === 418) {
        creationSuccessOrError(
          `Erro ao criar CPR! Selecione uma data de assinatura válida.`,
          false
        );
        setLoad(false);
        return
      }
      // DO NOT REMOVE

      if(!['institucional'].includes(typeUser)) {
        console.log('GENERATE DOCUMENT')
        const response2 = await PostFetch(`/financial/${createPDF}`, {
          cpr_number: response.data.cpr_number,
          personne_id: response.data.personne_id,
        });
      }

      if (note.length > 0) {
        const noteResponse = await handleNote(
          response.data.id,
          note,
          user.username
        );
      }

      if (response.data.cpr_number) {
        creationSuccessOrError(
          `CPR nº ${response.data.cpr_number} criada com sucesso`,
          true
        );
      }
      navigate("/cprf/geradas");
    } catch (error) {
      creationSuccessOrError(
        `Erro ao criar CPR! ${error.response.data.error}`,
        false
      );
    } finally {
      setLoad(false);
    }
  };

  const handleCreateOpportunityCPR = async (
    personne,
    amount,
  ) => {
    try {
      setLoad(true);
      if (!personne) {
        creationSuccessOrError("Selecione um Cliente");
        return;
      }
      if (!amount) {
        creationSuccessOrError("Insira o valor do investimento");
        return;
      }
      if (opportunityErrorAmount) {
        creationSuccessOrError("Valor do investimento está fora do estabelecido pela oportunidade.");
        return;
      }

      const user = JSON.parse(localStorage.getItem("user"));
          
      const requestData = {
        opportunity_id: opportunitySelected.id,
        personne_id: personne.value,
        amount_cpr: formatCurrencyToSave(amount_cpr),
        username: user.username,
        date_start: formatDate(opportunitySelected.date_start),
      };

      let typeUser = "cliente";
      if (personne.user?.length > 0) {
        const [userType] = personne.user;
        console.log("userType", { type: userType.type });
        typeUser = userType.type;
      }

      const response = await PostFetch(
        `/financial/opportunities/create-cpr`,
        requestData
      );
      if (response.data?.status === 418) {
        creationSuccessOrError(
          `Erro ao criar CPR! Selecione uma data de assinatura válida.`,
          false
        );
        setLoad(false);
        return;
      }
      // DO NOT REMOVE

      if (!["institucional"].includes(typeUser)) {
        console.log("GENERATE DOCUMENT");
        const response2 = await PostFetch(`/financial/${createPDF}`, {
          cpr_number: response.data.cpr.cpr_number,
          personne_id: response.data.cpr.personne_id,
        });
      }

      if (note.length > 0) {
        const noteResponse = await handleNote(
          response.data.id,
          note,
          user.username
        );
      }

      if (response.data.cpr_number) {
        creationSuccessOrError(
          `CPR nº ${response.data.cpr_number} criada com sucesso`,
          true
        );
      }
      navigate("/cprf/geradas");
    } catch (error) {
      creationSuccessOrError(
        `Erro ao criar CPR! ${error.response.data.error}`,
        false
      );
    } finally {
      setLoad(false);
    }
  };

  const handleSubmit = async () => {
    if (isOpportunity) {
      await handleCreateOpportunityCPR(person_name_id, amount_cpr);
    } else {
      await handleCreateCPR(
        person_name_id,
        startDate,
        signDate,
        amount_cpr,
        cprType,
        rate_cpr,
        cprDuration
      );
    }
  };

  const floatConversor = (event) => {
    if (event.nativeEvent.data === ",") {
      setRate_cpr(rate_cpr + ".");
    } else {
      setRate_cpr(event.target.value);
    }
  };

  const handleFinalDate = (date) => {
    setAllowFinalDate(true);
    setFinalDate(date);
  };

  const handleFirstCupomDate = (date) => {
    setAllowFirstCupomDate(true);
    setFirstCupomDate(date);
  };

  const getCprsHeldByClient = async (clientId) => {
    try {
      const cprList = await GetFetch(
        `/financial/listPersonneCprsToRenew?personne_id=${clientId}`
      );
      setCprsHeldByClient(cprList.data.length > 0 ? cprList.data : []);
    } catch (error) {
      console.error(error);
      setCprsHeldByClient("error");
    }
  };

  const getSelectionOptions = (options) => {
    console.log({ options })
    if (options.length > 0) {
      return options;
    }

    return [{ label: "Carregando...", value: 0 }];
  };

  const setPersonInfo = (selection) => {
    if (!selection) {
      setSelectedPersonInfo(null);
      return;
    }

    let person = null;
    personneList.forEach((item) => {
      if (selection.id === item.id) {
        person = item;
        return;
      }
    });

    if (!person) {
      return;
    }

    // Make sure the values are not undefined before assigning them.
    let cpf;
    if (person.documents[0] !== undefined) {
      cpf = person.documents[0].document_number;
    }
    let bank_number, branch, account;
    if (person.bank_accounts[0] !== undefined) {
      bank_number = person.bank_accounts[0].bank_number;
      branch = person.bank_accounts[0].bank_agency;
      account = person.bank_accounts[0].account_number;
    }
    const salary = person.salary;
    setSelectedPersonInfo({
      cpf: cpf,
      bank: {
        bank_number: bank_number,
        branch: branch,
        account: account,
      },
      saldo: salary,
    });
  };

  const customFilter = (option, { inputValue }) => {

    setQuery(inputValue)

    return selectOptions; 
    // Escape special characters from the user input and create a regular expression
    const escapedInput = inputValue.replace("/[.*+?^${}()|[]\\]/g", "\\$&");
    // "i" flag makes it case-insensitive
    const regex = new RegExp(escapedInput, "i");

    const filteredOptions = [];
    selectOptions.forEach((item) => {
      if (regex.test(item.label)) {
        filteredOptions.push(item);
      }
    });

    return filteredOptions;
  };

  /** Show information regarding the selected client. */
  const showSelectionInfo = (personneInfo) => {
    if (personneInfo === null) {
      return <></>;
    }
    const salary = personneInfo.salary;
    const info = `
      CPF: ${personneInfo.cpf} 
      Salário: ${salary ? salary : "Não informado"} 
      Banco: ${personneInfo.bank.bank_number} 
      Agência: ${personneInfo.bank.branch} 
      Conta: ${personneInfo.bank.account}
    `;
    return <TextField fullWidth variant="outlined" value={info} />;
  };

  const showClientsCprList = (clientCpr, cprToRenew) => {
    if (clientCpr === "error") {
      return (
        <TextField
          fullWidth
          variant="outlined"
          value="Ocorreu um erro ao buscar as CPRFs."
        />
      );
    }

    if (clientCpr.length == 0) {
      return (
        <TextField
          fullWidth
          variant="outlined"
          value="Não foram encontradas CPRFs associadas a esse cliente."
        />
      );
    }

    const textFieldList = clientCpr.map((cpr) => (
      <Box display={"flex"} alignItems={"center"}>
        <input
          type="checkbox"
          checked={cprToRenew.includes(cpr.id)}
          onChange={() => handleRenewListChange(cpr.id, cprsSelectedToRenew)}
          style={{
            width: "2em",
            height: "2em",
            marginRight: "1em",
          }}
        />
        <TextField
          key={cpr.cpr_number}
          fullWidth
          variant="outlined"
          value={`
            Número da CPR: ${cpr.real_number || cpr.cpr_number},
            Id da CPRF: ${cpr.id}
            Status: ${cpr.status} 
            Tipo: ${cpr.type} 
            Valor: ${formatCurrency(cpr.amount_cpr)} 
            Data de Assinatura: ${moment(cpr.date_signed).format("DD/MM/yyyy")}
          `}
        />
      </Box>
    ));

    return <>{textFieldList}</>;
  };

  /** Add an id to the list if it does not exist, or remove if it is already there. */
  const handleRenewListChange = (cpr_id, cprToRenew) => {
    const newArray = [];
    if (cprToRenew.length == 0) {
      newArray.push(cpr_id);
    } else {
      let found = false;
      cprToRenew.forEach((cpr) => {
        if (cpr != "undefined") {
          if (cpr == cpr_id) {
            found = true;
          } else {
            newArray.push(cpr);
          }
        }
      });
      if (!found) {
        newArray.push(cpr_id);
      }
      newArray.sort((a, b) => a - b);
    }
    setCprsSelectedToRenew(newArray);
  };

  const selectOptionalDates = (isType) => {
    return (
      isType === "cupom" || isType === "ipca_cupom" || isType === "cdi_cupom"
    );
  };

  /** If personne is not loaded, return false. */
  const checkForEmptyPersonne = (personnes) => {
    if (personnes === null) {
      return false;
    } else if (
      typeof personnes === "object" &&
      Object.keys(personnes).length === 0
    ) {
      return false;
    }
    return true;
  };

  const setClientTime = (value) => {
    const item = clientTimeDict.find((item) => item.cprDuration === value)
    console.log(item)
    setSelectedClientTime(item)
    setKeyTime(item.keyTime)
    setCprDuration(item.cprDuration)
  }

  useEffect(() => {
    handleLoadPersonne();
    getCreatePDF();
    handleLoadOpportunities()
  }, []);

  useEffect(() => {
    if (isRenew) {
      getCprsHeldByClient(person_name_id.value);
    } else {
      setCprsHeldByClient([]);
    }
  }, [isRenew]);

  useEffect(() => {
    setIsRenew(false);
    setCprsSelectedToRenew([]);
    

    if (person_name_id?.user?.length > 0) {
      const [ userType ] = person_name_id.user
      setClientType(userType.type)

      if(userType.type === 'cliente') {
        setKeyTime(selectedClientTime.keyTime)
        setCprDuration(selectedClientTime.cprDuration)
      } else {
        setKeyTime('years')
        setCprDuration(1)
      }
      
    }

  }, [person_name_id]);

  useEffect(() => {
    if (opportunitySelected) {
      setAmount_cpr(opportunitySelected.min_amount)
    }
  }, [opportunitySelected]);

  useEffect(() => {
    if (opportunitySelected) {
      if (
        (opportunitySelected.min_amount > amount_cpr) ||
        (amount_cpr > (opportunitySelected.max_amount - opportunitySelected.total_amount))
      ) {
        setOpportunityErrorAmount(true);
      } else {
        setOpportunityErrorAmount(false);
      }
    }
  }, [amount_cpr]);

  return (
    <>
      <FixedContainer>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#F9FBFD",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            boxShadow: 3,
            borderRadius: "10px",
            padding: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, fontSize: "18px", paddingBottom: 1 }}
          >
            CPRF's/Nova CPRF
          </Typography>

          <FormControl fullWidth sx={{ gap: 2 }}>
            <FormControl fullWidth>
              <Autocomplete
                onChange={(event, newValue) => {
                  setPersonne_name_id(newValue);
                  setPersonInfo(newValue);
                }}
                disablePortal
                id="combo-box-demo"
                options={getSelectionOptions(selectOptions)}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => {
                  return option.value === value.value;
                }}
                filterOptions={customFilter}
                value={person_name_id}
                loading={initLoadSuccess}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Selecione o cliente" />
                )}
                
              />
            </FormControl>

            {showSelectionInfo(selectedPersonInfo)}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <label>
                Deseja criar essa CPRF a partir de uma oportunidade?
              </label>
              <Box display="flex" alignItems="center">
                <FormControl fullWidth size="small">
                  <Select
                    id="opportunity-simple-select"
                    value={isOpportunity}
                    disabled={person_name_id === null}
                    onChange={(e) => setIsOpportunity(e.target.value)}
                  >
                    <MenuItem value={true}>Sim</MenuItem>
                    <MenuItem value={false}>Não</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            {!isOpportunity && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <label>É Renovação?</label>
                <Box display="flex" alignItems="center">
                  <FormControl fullWidth size="small">
                    <Select
                      id="renew-dropbox"
                      value={
                        isRenewSelected
                          ? isRenew
                            ? "Sim"
                            : "Não"
                          : "default"
                      }
                      disabled={person_name_id === null}
                      onChange={(e) => {
                        if (!isRenewSelected) {
                          setIsRenewSelected(true);
                        }
                        setIsRenew(e.target.value === "Sim");
                      }}
                    >
                      <MenuItem value="Sim">Sim</MenuItem>
                      <MenuItem value="Não">Não</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            )}

            {isRenewSelected && !isOpportunity && (
              <>
                {isRenew &&
                  showClientsCprList(cprsHeldByClient, cprsSelectedToRenew)}

                <Box sx={{ display: "flex", gap: 2 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      label="Data de geração"
                      value={startDate}
                      format="DD/MM/YYYY"
                      onChange={(newValue) => setStartDate(newValue)}
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <DatePicker
                      label="Data de assinatura"
                      value={signDate}
                      shouldDisableDate={isWeekend}
                      format="DD/MM/YYYY"
                      onChange={(newValue) => setSignDate(newValue)}
                    />
                  </FormControl>
                </Box>

                <FormControl fullWidth>
                  <InputLabel htmlFor="outlined-adornment-amount">
                    Valor do investimento
                  </InputLabel>
                  <OutlinedInput
                    required
                    id="outlined-adornment-amount"
                    startAdornment={
                      <InputAdornment position="start">R$</InputAdornment>
                    }
                    label="Valor do investimento"
                    value={amount_cpr !== undefined ? formatCurrency(amount_cpr) : ''} // Formata o valor para exibição
                    onChange={(event) => setAmount_cpr(formatToDecimal(event.target.value))} // Aplica a máscara durante a mudança
                  />
                </FormControl>

                <Box display="flex" sx={{ gap: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Selecione o registro
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Selecione o registro"
                      value={registerMode}
                      onChange={(e) => setRegisterMode(e.target.value)}
                    >
                      <MenuItem key={0} value={"B3"}>
                        B3
                      </MenuItem>
                      <MenuItem key={1} value={"BRP"}>
                        BRP
                      </MenuItem>
                      <MenuItem key={2} value={"OUTROS"}>
                        Outros
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Selecione o broker
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Selecione o broker"
                      value={brokerage}
                      onChange={(e) => setBrokerage(e.target.value)}
                    >
                      <MenuItem key={0} value={"BRP"}>
                        BRP
                      </MenuItem>
                      <MenuItem key={1} value={"OUTROS"}>
                        Outros
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Selecione a custodia
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Selecione a custodia"
                      value={custody}
                      onChange={(e) => setCustody(e.target.value)}
                    >
                      <MenuItem key={0} value={"FINPEC"}>
                        FinPec
                      </MenuItem>
                      <MenuItem key={1} value={"NOVA FUTURA"}>
                        Nova Futura
                      </MenuItem>
                      <MenuItem key={2} value={"OUTROS"}>
                        Outros
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Selecione o instrumento
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Selecione o instrumento"
                      value={instrumentType}
                      onChange={(e) => setInstrumentType(e.target.value)}
                    >
                      <MenuItem key={0} value={"CPR"}>
                        CPR
                      </MenuItem>
                      <MenuItem key={1} value={"CRA"}>
                        CRA
                      </MenuItem>
                      <MenuItem key={2} value={"CDCA"}>
                        CDCA
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <Box display="flex" sx={{ gap: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Selecione o tipo
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Selecione o tipo"
                      value={cprType}
                      onChange={(e) => setCprType(e.target.value)}
                    >
                      <MenuItem key={0} value={"bullet"}>
                        Bullet
                      </MenuItem>
                      <MenuItem key={1} value={"cupom"}>
                        Cupom
                      </MenuItem>
                      <MenuItem key={2} value={"ipca_bullet"}>
                        IPCA+ Bullet
                      </MenuItem>
                      <MenuItem key={3} value={"ipca_cupom"}>
                        IPCA+ Cupom
                      </MenuItem>
                      <MenuItem key={4} value={"cdi_bullet"}>
                        CDI+ Bullet
                      </MenuItem>
                      <MenuItem key={5} value={"cdi_cupom"}>
                        CDI+ Cupom
                      </MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Incluir taxa de Ativação
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Incluir taxa de Ativação"
                      value={brokerageTax}
                      onChange={(e) => setBrokerageTax(e.target.value)}
                    >
                      <MenuItem key={0} value={true}>
                        Sim
                      </MenuItem>
                      <MenuItem key={1} value={false}>
                        Não
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {selectOptionalDates(cprType) && (
                  <>
                    <DatePicker
                      label="Data do primeiro cupom (Opcional)"
                      value={firstCupomDate}
                      format="DD/MM/YYYY"
                      onChange={(newValue) => handleFirstCupomDate(newValue)}
                    />

                    <DatePicker
                      label="Data final da CPR (Opcional)"
                      value={finalDate}
                      format="DD/MM/YYYY"
                      onChange={(newValue) => handleFinalDate(newValue)}
                    />
                  </>
                )}

                <FormControl fullWidth>
                  <InputLabel htmlFor="outlined-adornment-amount">
                    Taxa
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-amount"
                    endAdornment={
                      <InputAdornment position="end">%</InputAdornment>
                    }
                    label="Taxa"
                    value={rate_cpr}
                    onChange={(event) => {
                      floatConversor(event);
                    }}
                  />
                </FormControl>

                {clientType === 'cliente' && (
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Selecione o tempo de investimento
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Selecione o período"
                        value={selectedClientTime.cprDuration}
                        onChange={(e) => setClientTime(e.target.value)}
                      >
                        {
                          clientTimeDict.map((item, index) => (
                            <MenuItem key={index} value={item.cprDuration}>{item.label}</MenuItem>
                          ))
                        }

                      </Select>
                    </FormControl>
                  </Box>
                    )}

                    {clientType === 'institucional' && (
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <FormControl fullWidth>
                        <TextField
                          id="outlined-number"
                          label="Tempo de investimento"
                          type="number"
                          value={cprDuration}
                          onChange={(event) => {
                            setCprDuration(event.target.value);
                          }}
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Selecione o período
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Selecione o período"
                          value={keyTime}
                          defaultValue={"years"}
                          onChange={(e) => setKeyTime(e.target.value)}
                        >
                          <MenuItem value={"days"}>Dias</MenuItem>
                          <MenuItem value={"months"}>Meses</MenuItem>
                          <MenuItem value={"years"}>Anos</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                    )}
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Observação (Opcional)"
                  variant="outlined"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </>
            )}

            {isOpportunity && (
              <>
                <FormControl fullWidth>
                  <Autocomplete
                    onChange={(event, newValue) => {
                      setOpportunitySelected(newValue);
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={opportunitiesList}
                    getOptionLabel={(option) => option.title}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id;
                    }}
                    value={opportunitySelected}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.id}>
                          {option.title}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecione a oportunidade"
                      />
                    )}
                  />
                </FormControl>

                {opportunitySelected && (
                  <>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="outlined-adornment-amount">
                        Valor do investimento
                      </InputLabel>
                      <OutlinedInput
                        required
                        id="outlined-adornment-amount"
                        startAdornment={
                          <InputAdornment position="start">R$</InputAdornment>
                        }
                        label="Valor do investimento"
                        value={amount_cpr !== undefined ? formatCurrency(amount_cpr) : ''} // Formata o valor para exibição
                        onChange={(event) => setAmount_cpr(formatToDecimal(event.target.value))} // Aplica a máscara durante a mudança
                        error={opportunityErrorAmount}
                      />
                    </FormControl>

                    {opportunityErrorAmount && (
                      <Typography
                        sx={{
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "red",
                        }}
                      >
                        {`O valor do investimento deve estar entre o valor mínimo (${Intl.NumberFormat(
                          "pt-BR",
                          {
                            style: "currency",
                            currency: "BRL",
                          }
                        ).format(
                          opportunitySelected.min_amount
                            ? opportunitySelected.min_amount
                            : 0
                        )}) e o valor máximo (${Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(
                          opportunitySelected.max_amount
                            ? opportunitySelected.max_amount -
                                opportunitySelected.total_amount
                            : 0
                        )}) da oportunidade.`}
                      </Typography>
                    )}

                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        paddingBottom: 1,
                      }}
                    >
                      {Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(amount_cpr ? amount_cpr : 0)}
                    </Typography>

                    <Box sx={{ display: "flex", gap: 2 }}>
                      <FormControl fullWidth>
                        <DatePicker
                          label="Data de geração"
                          value={dayjs(opportunitySelected.date_start)}
                          format="DD/MM/YYYY"
                          disabled
                        />
                      </FormControl>
                    </Box>

                    <FormControl fullWidth>
                      <InputLabel htmlFor="outlined-adornment-rate">
                        Taxa
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-rate"
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="Taxa"
                        value={opportunitySelected.rate}
                        disabled
                      />
                    </FormControl>
                      <Box sx={{ display: "flex", gap: 2 }}>
                      <FormControl fullWidth>
                        <TextField
                          id="outlined-number"
                          label="Tempo de investimento"
                          type="number"
                          value={opportunitySelected.duration}
                          disabled
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Selecione o período
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Selecione o período"
                          value={opportunitySelected.duration_unit}
                          defaultValue={"years"}
                          disabled
                        >
                          <MenuItem value={"days"}>Dias</MenuItem>
                          <MenuItem value={"months"}>Meses</MenuItem>
                          <MenuItem value={"years"}>Anos</MenuItem>
                        </Select>
                      </FormControl>
                      </Box>
                  </>
                )}
              </>
            )}
          </FormControl>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 2,
            }}
          >
            <Button
              variant={"contained"}
              color="success"
              sx={{ paddingRight: 2 }}
              onClick={() => handleSubmit()}
              disabled={load}
              loadingposition="start"
            >
              {load ? (
                <CircularProgress size={30} color="success" />
              ) : (
                "Salvar"
              )}
            </Button>
          </Box>
        </Box>
      </FixedContainer>
    </>
  );
};

export default NewCpr;
